import script from "./SociosView.vue?vue&type=script&setup=true&lang=js"
export * from "./SociosView.vue?vue&type=script&setup=true&lang=js"

import "./SociosView.vue?vue&type=style&index=0&id=3bc21c8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc21c8e"]])

export default __exports__